import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PopupService } from 'src/app/services/popup.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-how-to-buy',
  templateUrl: './how-to-buy.component.html',
  styleUrls: ['./how-to-buy.component.scss']
})
export class HowToBuyComponent {
  
  contactForm!: FormGroup;
  isSubmitted = false;

  constructor(
    public meta: Meta,
    public title: Title,
    private http: HttpClient,
    private popupService: PopupService,
    private router: Router,
    private translate: TranslateService,
    private formBuilder: FormBuilder,
  ) {
    this.meta.updateTag({ name: 'description', content: "Buy Love Hate Inu in presale by connecting your MetaMask or Trust Wallet. You can purchase $LHINU tokens with ETH, USDT, or fiat bank card." });
    this.title.setTitle("Help - How To Buy Love Hate Inu - Best Vote-to-Earn Meme Coin");

    const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.contactForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(EMAIL_REGEXP)]],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      phone: ['', Validators.required],
      besttime: ['Morning', Validators.required],
      budget: ['$1-10k', Validators.required],
    });
   }

  ngOnInit(): void {
    window.scrollTo(0,0);
  }

  get f() { return this.contactForm.controls; }

  onSubmit() {
    if (this.isSubmitted)
      return;
    if (this.checkForm()) {
      let req = this.contactForm.value;
      this.http.post(environment.apiURL, req).subscribe((res) => {
        this.isSubmitted = true;
        this.popupService.messagePopup("success", this.translate.instant("formSuccess")).then(() => {
          this.router.navigate(['/']);
        });
      },
      (err) =>{
        this.popupService.messagePopup("error", this.translate.instant("formError"));
      });
      //do something
    }
  }

  checkForm(): boolean {
    this.contactForm.updateValueAndValidity();
    if (this.f['email'].errors || this.f['firstname'].errors || this.f['lastname'].errors || this.f['phone'].errors || this.f['budget'].errors || this.f['besttime'].errors) {
      return false;
    }
    return true;
  }
}
